/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Contact_Languages_LabelInputs */

const es_privacy_policy_contact_languages_label = /** @type {(inputs: Privacy_Policy_Contact_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas de Atencion`)
};

const en_privacy_policy_contact_languages_label = /** @type {(inputs: Privacy_Policy_Contact_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Languages`)
};

/**
* | output |
* | --- |
* | "Support Languages" |
*
* @param {Privacy_Policy_Contact_Languages_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_contact_languages_label = /** @type {((inputs?: Privacy_Policy_Contact_Languages_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Contact_Languages_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_contact_languages_label(inputs)
	return en_privacy_policy_contact_languages_label(inputs)
});
export { privacy_policy_contact_languages_label as "privacy_policy.contact.languages_label" }